
<template>
	<div class="loadItem">
		<div class="loadHead" v-if="load">
			<div class="title">
				<div class="text">Billing</div>
<!--				<button @click="onGuide" type="button" class="mainBtn mainBtn-text">-->
<!--					<span class="btnIco"><svg-sprite icon-id="attention" width="20" height="20"></svg-sprite></span>-->
<!--				</button>-->
			</div>
			<div class="contract_btn">
				<button
						@click="onCreateInvoice"
						type="button"
						class="mainBtn mainBtn-text"
						:disabled="!isBol"
				>
          <span class="btnIco"><svg-sprite icon-id="generateFile" width="20" height="20"></svg-sprite></span>
					<span class="btnText">Generate invoice</span>
				</button>
			</div>
		</div>

		<div class="loadMain billingField" v-if="typeBilling">
			<field
					margin="0"
					label="Invoice date"
					:setInputValue="load.billing.date"
					is-readonly
			></field>
			<field
					margin="0"
					label="Invoiced by"
					:setInputValue="load.billing.invoice_by"
					is-readonly
			></field>
			<field
					margin="0"
					label="Ref#"
					:setInputValue="load.billing.ref"
					is-readonly
			></field>
			<field
					margin="0"
					label="Invoiced file"
					:setInputValue="fileName"
					iconGap="10px"
			>
				<template slot="additionalElements">
					<field-custom-icon-buttons
							v-for="(button, index) in customIconButtonsList"
							:key="button.icon"
							:index="index"
							:button="button"
							:item="load.billing"
							@updateCustomIconButton="onCustomIconButton($event, 'fileBilling')"
					></field-custom-icon-buttons>
				</template>
			</field>
		</div>
	</div>
</template>

<script>
import FieldCustomIconButtons from "@/shared/Field/FieldCustomIconButtons.vue";

import { PAGE } from "@/constants/constants";

export default {
	name: "Billing",
	components: {
		FieldCustomIconButtons
	},
	props: {
		load: Object,
		typeBilling: [ String, Number ],
		ppw: String,
	},
	watch: {
		typeBilling(val, oldVal) {
			if (val !== oldVal) {
				this.isBol;
			}
		},
		ppw(val, oldVal) {
			if (val !== oldVal) {
				this.customIconButtonsList;
			}
		},
	},
	computed: {
		isBol() {
			if (!this.load.billing.type && !this.load.ppw_date) {
				return this.load.file.some(function(file) {
					return (file.type === "2" && file.status !== 0) || (file.type === "2" && file.status !== 'active');
				}); 
			}
			return false;
		},
		fileName() {
			return this.load.billing.file.split('/').pop();
		},
		customIconButtonsList() {
			if (this.load.ppw_date) {
				return [
					{
						icon: "icon_view",
					},
					{
						icon: "icon_download",
					},
					{
						icon: "deleteItem",
						disabled: true,
					},
				];
			}
			return [
				{
					icon: "icon_view",
				},
				{
					icon: "icon_download",
				},
				{
					icon: "deleteItem",
				},
			];
		},
	},

	methods: {
		onGuide() {
			this.$emit('updateGuide', PAGE.TRIP_BILLING);
		},
		onCreateInvoice() {
			this.$emit('updateCreateInvoice');
		},
		onCustomIconButton(btn, key) {
			this.$emit('updateCustomIconButton', { key, btn });
		},
	},
};
</script>
<style lang="scss">
.loadMain {
	.pagination {
		padding: 20px 0 10px;
	}
}
</style>
<style scoped lang="scss">
@import "../loadItem";
.loadMain {
	&.billingField {
		display: grid;
		grid-gap: 10px;
		grid-template-columns: 1fr 1fr 1fr 1fr;
	}
}
</style>
